var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-button',_vm._b({class:[_vm.useColor ? 'color' : ''],style:({
    '--color': _vm.color
  }),attrs:{"type":_vm.type,"size":_vm.size,"lineColor":_vm.lineColor,"faceColor":_vm.faceColor,"textColor":_vm.textColor},on:{"click":_vm.click}},'nx-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }